// Work kit announce helper (W8 Track C; created here because no merged wave
// had landed app/javascript/lib/work/announce.js at wave start). Copy of the
// flow F9 machinery (flow_controller.js DEFAULT_ANNOUNCEMENTS + _announce):
// fixed keys, host-overridable free-text values, {token} interpolation, one
// sr-only polite live region per surface.
//
// Consumers: the engine resolves copy as
//   (this.announcementsValue || {})[key] || DEFAULTS[key] || ""
// so a PARTIAL host override stays complete (a missing key falls back).

export const TIMELINE_ANNOUNCEMENTS = {
  moved: "{label} moved to {start_date} – {end_date}",
  resized: "{label} resized to {start_date} – {end_date}",
  cancelled: "Move cancelled",
  undone: "Change undone",
  redone: "Change redone",
  disabled: "{label} cannot be edited",
}

// {token} interpolation — a MISSING token keeps its {name} placeholder
// visible (the flow parity is the regex + free-text values; flow's own
// missing-token fallback differs by one layer: flow substitutes "" because
// its templates always resolve every token, ours leaves the marker so an
// unnoticed template/token typo is loud instead of silently blank).
export function interpolate(template, tokens = {}) {
  return String(template ?? "").replace(/\{(\w+)\}/g, (match, name) =>
    tokens[name] ?? match,
  )
}

// Resolve the copy for one key through the host override → default chain.
export function resolveAnnouncement(overrides, key) {
  return (overrides || {})[key] || TIMELINE_ANNOUNCEMENTS[key] || ""
}

// The surface's live region: ONE sr-only polite announcer per engine root,
// created idempotently (a reconnect after a Turbo restore must not stack a
// second region — D1).
export function ensureAnnouncer(root, attr = "data-work-announcer") {
  let region = root.querySelector(`[${attr}]`)
  if (!region) {
    region = document.createElement("div")
    region.setAttribute(attr, "")
    region.setAttribute("aria-live", "polite")
    region.setAttribute("aria-atomic", "true")
    region.className = "sr-only"
    root.appendChild(region)
  }
  return region
}

// Announce into a region: textContent cleared then set (the flow rule — a
// repeated identical message re-announces because the node empties first).
export function announce(region, template, tokens = {}) {
  if (!region) return
  region.textContent = ""
  region.textContent = interpolate(template, tokens)
}
